export const CALCULATION_STEP = {
    'CALCULATION_STEP.ACTION.NEXT_STEP': 'Pasul următor',
    'CALCULATION_STEP.ACTION.PREVIOUS_STEP': 'Înapoi',
    'CALCULATION_STEP.ACTION.SAVE': 'Salvează',
    'CALCULATION_STEP.ACTION.CANCEL': 'Anulează',
    'CALCULATION_STEP.ACTION.BALANCE_ACCOUNTS': 'Conturi',
    'CALCULATION_STEP.ACTION.ADD_ROW': 'Adaugă rând',
    'CALCULATION_STEP.ACTION.REUSE_DOCUMENTS': 'Reutilizează documente suport',
    'CALCULATION_STEP.DRAWER.ACTION.UPDATE': 'Actualizează',
    'CALCULATION_STEP.DRAWER.MAPPED_ACCOUNTS': 'Mapate',
    'CALCULATION_STEP.DRAWER.UNMAPPED_ACCOUNTS': 'Nemapate'
};
